import "core-js/modules/es.array.map.js";
import { SocialIcon } from 'react-social-icons';
import Colors from "../../Color/Colors";
import { Container } from "../../Container/Container/Container";
import { Text } from "../../Text/Text/Text";
import { Theme } from "../../Background/Theme/Theme";
import { Image } from "../../Image/Image/Image";
import styles from "./AuthorMasthead.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AuthorMasthead = function AuthorMasthead(_ref) {
  var name = _ref.name,
    jobTitle = _ref.jobTitle,
    _ref$photo = _ref.photo,
    photo = _ref$photo === void 0 ? '' : _ref$photo,
    _ref$bio = _ref.bio,
    bio = _ref$bio === void 0 ? '' : _ref$bio,
    _ref$social = _ref.social,
    social = _ref$social === void 0 ? [] : _ref$social;
  return /*#__PURE__*/_jsx(Theme, {
    theme: 'darkBackground',
    children: /*#__PURE__*/_jsx("section", {
      className: styles.authorMastheadWrapper,
      children: /*#__PURE__*/_jsxs(Container, {
        innerClassName: styles.authorMastheadInner,
        children: [photo && /*#__PURE__*/_jsx("div", {
          className: styles.photoWrapper,
          children: /*#__PURE__*/_jsx(Image, {
            className: styles.authorPhoto,
            width: '80',
            height: '80',
            src: photo
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.contentWrapper,
          children: [/*#__PURE__*/_jsx(Text, {
            className: styles.name,
            typog: "headline4",
            children: name
          }), /*#__PURE__*/_jsx(Text, {
            className: styles.title,
            typog: "bodycopy",
            children: jobTitle
          }), bio && /*#__PURE__*/_jsx(Text, {
            className: styles.bio,
            typog: "bodycopyLarge",
            children: bio
          }), social !== null && social !== void 0 && social.length ? /*#__PURE__*/_jsx("div", {
            className: styles.socialWrapper,
            children: social.map(function (url, idx) {
              if (url) {
                return /*#__PURE__*/_jsx(SocialIcon, {
                  bgColor: Colors.colorWhite,
                  url: url,
                  style: {
                    height: 28,
                    width: 28
                  },
                  className: styles.icon
                }, idx);
              } else {
                return null;
              }
            })
          }) : null]
        })]
      })
    })
  });
};